import { network } from 'services/network';
import { useQuery } from 'react-query';
import {
    IAssignee,
    IStatus,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

const getLogicCheckerCategoryResults = (params) => {
    return network.post('api/bo/getLogicCheckerCategoryResults', params).then((response) => {
        return response.data;
    });
};
export const useQueryGetLogicCheckerCategoryResults = (params) => {
    return useQuery<ILogicCheckerCategoryResultsResponse, QueryError>(
        ['getLogicCheckerCategoryResults', params],
        () => getLogicCheckerCategoryResults(params),
        {
            enabled: Boolean(params.fileMetaDataId),
        },
    );
};

export interface ILogicCheckerCategoryResultsResponse {
    categoriesSummaryHeaders: {
        accessor: string;
        clickable: boolean;
        colorable: boolean;
        header: string;
        order: number;
        sortable: string;
    }[];
    categoriesSummaryRows: {
        category: string;
        complianceColor: string;
        compliantActivities: number;
        compliantActivitiesPersent: string;
        nonCompliantActivities: number;
        nonCompliantActivitiesPersent: string;
        scoreImpact: number;
        validationHeaders: {
            accessor: string;
            clickable: boolean;
            colorable: boolean;
            header: string;
            order: number;
            sortable: string;
        }[];
        validationRows: {
            complianceColor: string;
            compliantActivities: number;
            compliantActivitiesPersent: string;
            nonCompliantActivities: number;
            nonCompliantActivitiesPersent: string;
            scoreImpact: number;
            validationId: number;
            validationName: string;
            dcma: boolean;
            mandatory: boolean;
            associatedCard: {
                cardId: null | number;
                status: IStatus;
                assignee: IAssignee;
            };
        }[];
    }[];
    title: string;
}
